import React, { useContext } from "react";
import { GlobalContext } from "../../contexts/GlobalContext";
import "./LoadProfile.css";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import PageTitle from "../../components/PageTitle/PageTitle";
import CardInfoIcon from "../../components/CardInfoIcon/CardInfoIcon";
import CardTreatment from "../../components/CardInfoIcon/CardTreatment";
import getImage from "../../useFull/getImage";

const LoadProfile = () => {
  const { state } = useContext(GlobalContext);
  const language = state.language || "pt-br";
  const {
    breadcrumb,
    selectedPage,
    breadCrumbImage,
    pageTitle,
    pageSubtitle,
    segmentsList1,
    treatmentTitle,
    treatmentSubtitle,
    dangerousArticlesTitle,
    dangerousArticlesSubtitle,
    dangerousArticlesItens,
    articleTransported,
    articleTransportedSubtitle,
    listOfArticlesTransported
  } = require(`../../assets/languages/${language}/loadProfile.json`);
  return (
    <>
      <Breadcrumb
        beforeRoutes={breadcrumb}
        classColor="white100"
        selectedPage={selectedPage}
        image={breadCrumbImage}
      />
      <div className="main-container bg-gray100 mg-bot">
        <section className="section-container">
          <PageTitle title={pageTitle} subtitle={pageSubtitle} />
          <div className="container-card-info mg-bot-100">
            {segmentsList1.map((d, i) => (
              <CardInfoIcon
                key={i}
                iconName={d.iconName}
                title={d.title}
                content={d.content}
                link={d.link}
                textLink={d.textLink}
                afterLink={d.afterLink}
              />
            ))}
            <CardTreatment
              title={treatmentTitle}
              subtitle={treatmentSubtitle}
            />
          </div>
        </section>
      </div>
      <div className="main-container mg-bot-150">
        <section className="section-container">
          <div
            className="bg-icon mg-bot-20"
            style={{
              backgroundImage: `url(${getImage("icons", "alert-blue.png")})`,
            }}
          />
          <div className="mg-bot-100">
            <div className="mg-bot-30">
              <span
                className="text-title-secondary"
                dangerouslySetInnerHTML={{ __html: articleTransported }}
              ></span>
            </div>
            <div className="">
              <span>{articleTransportedSubtitle}</span>
            </div>
            {listOfArticlesTransported.map((d, i) => (
              <li key={i} className="mg-top-20 mg-l-10">{d.list}</li>
            ))}
          </div>
        </section>

        <section className="section-container background-container rounded bg-gray">
          <div className="container-content">
            <div
              className="bg-icon mg-bot-20"
              style={{
                backgroundImage: `url(${getImage("icons", "block.png")})`,
              }}
            />
            <div className="mg-bot-35">
              <span
                className="text-title-secondary mg-bot-30"
                dangerouslySetInnerHTML={{ __html: dangerousArticlesTitle }}
              ></span>
            </div>
            {/* <span className="mg-bot-30" >{dangerousArticlesSubtitle}</span> */}
            {dangerousArticlesItens.map((d, i) => (
              <li key={i} className={`list-profile ${i > 0 && "mg-top"}`}>
                <img
                  src={getImage("icons", `${d.icon}`)}
                  className="icon-image"
                  alt="icone"
                />
                <span dangerouslySetInnerHTML={{ __html: d.content }} />
              </li>
            ))}
          </div>
        </section>
      </div>
    </>
  );
};

export default LoadProfile;
